import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

@Component({
  selector: 'app-customer-limit',
  templateUrl: './customer-limit.component.html',
  styleUrls: ['./customer-limit.component.css']
})
export class CustomerLimitComponent implements OnInit {
  customerLimit = [];
  oldValidity;
  oldAmount;

  model = { 'table_name': 'customer_limit', 'acct_number': '', 'amount': '', 'validity': new Date(), 'comment': '' };

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<CustomerLimitComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) { }

  ngOnInit() {
    
    this.model['acct_number'] = this.dialog_data['acct_number'];
    let query1 = "SELECT * FROM `customer_limit` WHERE `customer_no` = '" + this.model['acct_number'] +
      "' AND `status` = '1' AND `validity` = (SELECT MAX(`validity`) FROM `customer_limit` WHERE `customer_no` = '" +
      this.model['acct_number'] + "' AND `status`='1')";

    let obj1 = { cmd: 'getList', query: query1 };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj1)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.customerLimit = data.data['list'];
        //console.log(this.customerLimit);
        if (this.customerLimit.length != 0) {
          this.oldAmount = this.customerLimit['0']['amount'];
          this.oldValidity = new Date(this.customerLimit['0']['validity']);
          this.oldValidity = this.oldValidity.getFullYear() + "-" + (this.oldValidity.getMonth() + 1) + "-" + 
            this.oldValidity.getDate();
        }
        else {
          this.oldAmount = "0";
          this.oldValidity = "";
        }
      });

  }

  add() {
    if (this.model['amount'] == '')
      alert(" الرجاء إدخال الحد الائتماني الجديد");
    else {
      let validity = this.model['validity'].getFullYear() + "-" + (this.model['validity'].getMonth() + 1) + "-" + 
        (this.model['validity'].getDate() + 1);
      this.model['validity'] = new Date(validity);

      let values = [];
      values.push(this.model);
      let obj = { cmd: 'add', values: values };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.dialogRef.close(this.dialog_data);
          }
          else
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
        });
    }
  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
